<template>
  <div class="card" style="padding:16px;">
    <div style="color:var(--muted); font-size:12px;">{{ title }}</div>
    <div style="font-size:24px; font-weight:700;">{{ value }}<span v-if="suffix" style="font-size:14px; color:var(--muted); margin-left:6px;">{{ suffix }}</span></div>
  </div>
</template>

<script>
export default {
  name: 'InsightCard',
  props: {
    title: { type: String, required: true },
    value: { type: [String, Number], required: true },
    suffix: { type: String, default: '' }
  }
}
</script>
